module.exports = __webpack_public_path__ + "static/media/delete.fda09e7c.svg";